import { useMonaco } from '@monaco-editor/react'
import { useEffect, useState } from 'react'

import { MONACO_THEMES } from '@/features/controller/configuration/utils/editor/monacoThemes'

let themesRegistered = false
let registrationPromise: Promise<void> | null = null

/**
 * Hook that ensures Monaco themes are registered globally on first use
 */
export function useMonacoThemes() {
  const monaco = useMonaco()
  const [themesReady, setThemesReady] = useState(themesRegistered)

  useEffect(() => {
    if (!monaco) return

    // Themes already registered
    if (themesRegistered) {
      setThemesReady(true)
      return
    }

    // Registration in progress - wait for existing promise
    if (registrationPromise) {
      registrationPromise.then(() => setThemesReady(true)).catch(console.error)
      return
    }

    // Start new registration
    registrationPromise = registerThemes(monaco)
    registrationPromise.then(() => setThemesReady(true)).catch(console.error)
  }, [monaco])

  return { monaco, themesReady }
}

async function registerThemes(monaco: any): Promise<void> {
  try {
    if (themesRegistered) return

    monaco.editor.defineTheme(MONACO_THEMES.editMode.name, MONACO_THEMES.editMode.definition)
    monaco.editor.defineTheme(MONACO_THEMES.readonlyMode.name, MONACO_THEMES.readonlyMode.definition)

    themesRegistered = true
  } catch (error) {
    registrationPromise = null
    throw error
  }
}
